import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import rem from 'polished/lib/helpers/rem';
import color from '@decisiv/design-tokens/lib/color';
import typography from '@decisiv/design-tokens/lib/typography';

// Monospace treatment for the full DIL URL shown on each endpoint row. The
// Actions toolkit CSS covers the layout; this is the one DIL-specific bit it
// doesn't provide.
export const EndpointUrl = styled.span`
  font-family: 'Roboto Mono', 'Courier New', monospace;
  font-size: ${rem(typography.size.alias.code)};
  color: ${toColorString(color.base.charcoal)};
  word-break: break-all;
`;
